import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PM_V2_Service } from '../../../Service/PM_V2/PM_V2.service';
import { PM_V2_Execution_Interface, PM_V2_Execution_Context_Interface } from '../../../Interface/PM_V2_Interface';

@Component({
  selector: 'app-pm-v2-execution-history',
  templateUrl: './PM_V2_ExecutionHistory.component.html',
  styleUrls: ['./PM_V2_ExecutionHistory.component.css']
})
export class PM_V2_ExecutionHistoryComponent implements OnInit {

  AssignmentItemID: number = 0;
  DataList: PM_V2_Execution_Interface[] = [];
  Context: PM_V2_Execution_Context_Interface | null = null;
  Procssing: boolean = false;
  Message: string = '';

  page:number=0;
  constructor(
    private PM_V2_Service: PM_V2_Service,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.AssignmentItemID = Number(this.route.snapshot.paramMap.get('id') || 0);
    this.ReadData();
  }

  ReadData() {
    if (this.AssignmentItemID <= 0) {
      return;
    }

    this.Procssing = true;

    this.PM_V2_Service.GetExecutionHistory(this.AssignmentItemID).subscribe(
      data => {
        this.Context = data.context;
        this.DataList = data.items || [];
        this.Procssing = false;
      },
      error => this.HandleError(error)
    );
  }


  Back() {
    history.back();
  }

  private HandleError(error: any) {
    this.Procssing = false;


    this.Message = 'خطا در دریافت تاریخچه.';
  }
}
